<template>
  <div class="bg-white absolute top-0 bottom-0 h-full w-full z-50" v-if="showSubMenu">
    <div class="relative w-full h-16">
      <img v-if="showSubMenu" @click="displayMainMenu()" class="back-icon cursor-pointer absolute" src="../../../assets/img/arrow.svg" height="50" width="30" alt="">
      <img v-if="showSubMenu" @click="displayMainPage(false)" class="close-icon cursor-pointer absolute" src="../../../assets/img/close.svg" height="30" width="20" alt="">
      <p class="title absolute px-4 py-4 text-2xl">{{currentSelected}}</p>
    </div>
    <ul class="sub-navigation px-4 py-2">
      <li @click="displayMobileMicroMenu(menu)" class="px-4 py-2 mb-2" :class="{'current-route': $route.name.includes(menu.key.toLowerCase())}" v-for="menu in getMenuContent">
        {{menu.key}}
        <i v-if="menu.microMenu" class="el-icon-arrow-right float-right mt-2"></i>
        <el-tag class="float-right" :type="'warning'" size="mini" v-if="menu.url === '#' && !menu.microMenu">coming soon</el-tag>
      </li>
    </ul>
  </div>
</template>

<script>
import Constants from '../../../Constants';

export default {
  name: 'SubPageNavigation',
  data() {
    return {
      menus: { ...Constants },
    };
  },
  computed: {
    currentSelected() {
      return this.$store.state.Global.currentSelectedSubMenu;
    },
    getMenuContent() {
      return this.menus.subMenu[this.currentSelected];
    },
    showSubMenu() {
      return this.$store.state.Global.subMobileMenu;
    },
  },
  methods: {
    /**
     *
     * @param value
     * @returns {Promise<void>}
     */
    async displayMainPage(value) {
      await this.$store.commit('Global/setProperty', { property: 'subMobileMenu', payload: value });
    },

    /**
     *
     * @returns {Promise<void>}
     */
    async displayMainMenu() {
      await this.$store.commit('Global/setProperty', { property: 'subMobileMenu', payload: false });
      await this.$store.commit('Global/setProperty', { property: 'mobileMenu', payload: true });
    },

    /**
     *
     * @param value
     * @returns {Promise<boolean>}
     */
    async displayMobileMicroMenu(value) {
      if (value.microMenu) {
        await this.displayMainPage(false);
        await this.$store.commit('Global/setProperty', { property: 'microMobileMenu', payload: true });
        await this.$store.commit('Global/setProperty', { property: 'currentSelectedMicroMenu', payload: value.key });
        return true;
      }

      // Push to route
      await this.displayMainPage(false);
      await this.$router.push(value.url);
      return true;
    },
  },
};
</script>

<style scoped lang="scss">
  .close-icon {
    right: 20px;
    top: 20px;
  }

  .back-icon {
    left: 20px;
    top: 20px;
  }

  .title {
    left: 70px;
  }

  .sub-navigation {
    li {
      cursor: pointer;

      &:hover {
        background: #ecf5ff;
      }
    }
  }
</style>
